import { ReactNode } from 'react';

import { Box, BoxProps, Stack, StackProps } from '@mui/material';

import { tokens } from '../../../../theme/generated/tokens';
import { useDrawerInstance } from '../../../drawer';
import { SettingsButton } from '../../data-table/settings/SettingsButton';

type Props = Omit<StackProps, 'children'> & {
  recordsCount?: ReactNode;
  bulkActions?: ReactNode;
  actions?: ReactNode;
  paginator?: ReactNode;
  showSettings?: boolean;
  recordsCountWrapperProps?: BoxProps;
  bulkActionsWrapperProps?: BoxProps;
  actionsWrapperProps?: StackProps;
  paginatorWrapperProps?: BoxProps;
};

export const TableHeader = ({
  recordsCount,
  bulkActions,
  actions,
  showSettings,
  paginator,
  recordsCountWrapperProps,
  bulkActionsWrapperProps,
  actionsWrapperProps,
  paginatorWrapperProps,
  ...props
}: Props) => {
  const { isInDrawer } = useDrawerInstance();
  showSettings ??= !isInDrawer;

  return (
    <Stack
      direction="row"
      display="grid"
      gridTemplateAreas={`"recordsCount bulkActions paginator actions"`}
      gridTemplateColumns="auto 1fr auto auto"
      alignItems="center"
      minHeight={36}
      pb={8}
      {...props}
    >
      {recordsCount !== undefined && (
        <Box
          gridArea="recordsCount"
          typography="A1"
          color={tokens.theme.fg.structural.secondary}
          {...recordsCountWrapperProps}
        >
          {recordsCount}
        </Box>
      )}
      {!!bulkActions && (
        <Box gridArea="bulkActions" {...bulkActionsWrapperProps}>
          {bulkActions}
        </Box>
      )}
      {!!paginator && (
        <Box gridArea="paginator" pl={8} {...paginatorWrapperProps}>
          {paginator}
        </Box>
      )}
      {(!!actions || showSettings) && (
        <Stack
          gridArea="actions"
          direction="row"
          gap={8}
          {...actionsWrapperProps}
        >
          {actions}
          {showSettings && <SettingsButton />}
        </Stack>
      )}
    </Stack>
  );
};
